<template>
  <div class="viewer-login">
  </div>
</template>

<script>
import User from '../../mixins/User'
import Auth from '../../mixins/Auth'

export default {
  name: 'component-viewer-login',

  mixins: [User, Auth],

  data() {
    return {
      
    }
  },

  props: {
    
  },

 
  mounted() {
    let urlParams = new URLSearchParams(location.search)
    let key = urlParams.get('viewer')
    if(key){
      this.viewerLogin(key).then(res => {
        console.log('getViewerLoginUrl', res.body)
        if(res.body && res.body.success && res.body.url)
          window.location = res.body.url
        else {
          // notif error
        }
      })
    }
    else{
      //notif error
    }
  },

 

  methods: {

  },
  watch: {

  }
}
</script>
